import { useEffect, useState } from 'react';
import { getTimeLeft, ITimeLeft } from './utils';

interface ICountdownProps {
  targetTs: number;
  onExpire?: () => void;
}

const Countdown: React.FC<ICountdownProps> = ({ targetTs, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState<ITimeLeft>(() => getTimeLeft(targetTs));

  useEffect(() => {
    const interval = setInterval(() => {
      const newTimeLeft = getTimeLeft(targetTs);
      setTimeLeft(newTimeLeft);

      if (newTimeLeft.total <= 0 && onExpire) {
        onExpire();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTs, onExpire]);

  return (
    <span>
      {timeLeft.days > 0 && <span>{timeLeft.days}d </span>}
      {(timeLeft.days > 0 || timeLeft.hours > 0) && <span>{timeLeft.hours}h </span>}
      {(timeLeft.days > 0 || timeLeft.hours > 0 || timeLeft.minutes > 0) && <span>{timeLeft.minutes}m </span>}
      <span>{timeLeft.seconds}s</span>
    </span>
  );
};

export default Countdown;
